module.exports = __webpack_public_path__ + "img/2.卓有成效的管理者（李国庆）.8dc521f2.jpg";